"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_LANDING_CAROUSEL = void 0;
exports.CREDIT_BUILDER_LANDING_CAROUSEL = {
    BUILD_YOUR_CREDIT: {
        ID: 'build_your_credit',
        TITLE: 'Build\nyour credit',
        MAIN_TEXT: 'Paying rent with Flex will extend your credit history and can even improve your credit score.'
    },
    PAY_RENT_ON_TIME: {
        ID: 'pay_rent_on_time',
        TITLE: 'Pay rent\n on time',
        MAIN_TEXT: 'Choose to pay your rent in full each month, or split into smaller payments that fit your schedule.\n\n'
    },
    IMPROVE_YOUR_CASH_FLOW: {
        ID: 'improve_your_cash_flow',
        TITLE: 'Improve your\n cash flow',
        MAIN_TEXT: 'Choosing to split your rent means smaller payments over the course of the month, allowing you to better align your rent and finances.'
    }
};
